<template>

<div class="phase-content">

    <div v-if='projectPhase.skipped == 1'>
            
        <phase-skipped></phase-skipped>

    </div>

    <div v-else-if='phase.multiple == 0'>
        
        <div v-if='isOwner'>
            
            <in-progress v-if='projectPhase.status == 0'></in-progress>
            <phase-ended v-if='projectPhase.status == 1'></phase-ended>

        </div>

        <div v-if='!isOwner'>

            <worker-form v-if='projectPhase.status == 0'></worker-form>
            <worker-ended v-if='projectPhase.status == 1'></worker-ended>

        </div>

    </div>

    <div v-else>

        <multi-phase></multi-phase>

    </div>

</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {
            
            this.isOwner = ( this.$parent.model.user_id == this.user.id );

        },

        data() {
            return {

                isOwner : false,
                isReady : false,
                phases  : [],
                daysLeft  : 0,
                hoursLeft : 0,
                finished  : false,
                
                project_phases  : [],
                project         : this.$parent.model,
                phase           : this.$parent.phase,
                projectPhase    : this.$parent.projectPhase,

                model : false,
                selectedPhase : false,

                pMdl : {
                    project_id : this.$route.params.id,
                    phase_id   : null,
                    info       : '',
                    start_date : null,
                    end_date   : null
                }
            }
        },

        methods : {


        },

        components : {

            'worker-form'   : require('./Worker/Form.vue').default,
            'worker-ended'  : require('./Worker/Ended.vue').default,
            'in-progress'   : require('./Owner/InProgress.vue').default,
            'phase-skipped' : require('./Skipped.vue').default,
            'phase-ended'   : require('./Owner/Ended.vue').default,
            'multi-phase'   : require('./MultiPhase.vue').default,

        }


    }
</script>
